// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1my_0","col":"styles_col__2rsxJ"};